/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Navigate, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Card, CardGroup, Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import MemberSummary from '../../../api/MemberSummary';
import ClaimStatusSummary from '../../../api/ClaimStatusSummary';
import SpendingAccountSummary from '../../../api/SpendingAccountSummary';
import ClaimsList from '../../../api/ClaimsList';
import RetryAPI from '../../../api/RetryAPI';
import FindCare from '../findcare/FindCare';
import Resources from '../resources/Resources';
import HttpErrorHandler from '../../../errorhandling/HttpErrorHandler';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../../errorhandling/HttpErrorCodes';
import ClientErrorWidget from '../../../errorhandling/ClientErrorWidget';
import './SpendingSummary.scss';
import APIEndpoints from '../../../api/APIEndpoints';
import MasterPermissions from '../../../api/MasterPermissions';
import { axiosInstance } from '../../../../api/axios';
import Skeleton from './ClaimsSkeleton';
import SpendingSummarySkeleton from './SpendingSummarySkeleton';
import Feature from '../../../../services/feature';
import CustomClientError from '../../../errorhandling/CustomClientError';
import { NoSpendingDataSVG } from '../../../img/NoDataFoundSVG';
import moment from 'moment';
import { findPercentage, getClaimCountByValue } from '../../../utils/common';
import ProgressBar from '../../progressbar/progressbar';
import { withTranslation } from 'react-i18next';
import PriceCompare from '../priceCompare/PriceCompare';
import { ClientErrorSVG } from '../../../img/ClientErrorSVG';
import ClientErrorImage from '../../../img/client-error.png';
import PaymentIconImage from '../../../img/payment-icon.png';
import HttpHeader from 'src/Member/shared/httpheader';
import SimpleCoverage from '../newCoverage/SimpleCoverage';
import PrimeWidget from '../primewidget/PrimeWidget';
import Talon from '../talon/Talon';
library.add(faArrowRight);

ClaimStatusSummary.claimStatus = [];
let claimsData = [];

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

class SpendingSummary extends Component {
  _isMounted = false;
  findCareWidgetMode = 2; //0 only for find provider button, 1 only for links, 2 for both links and button
  constructor(props) {
    super(props);
    this.state = {
      claimStatusLoading: true,
      spendingSummaryLoading: true,
      MemberFlag: true,
      getSpendingAccountSummary: '',
      gotoClaimsTab: false,
      clientErrorSS: false, //Spending Summary
      clientErrorCS: false, //Claim Status Summary
      statusCS: 200,
      serverError: false,
      isNotFound: false,
      isSpendingSummaryNotFound: false,
      isAPIFailed: false,
      isKeenan: false,
      isTalon: false,
    };
  }

  async componentDidMount() {
    this._isMounted = true;
    const { Features_Setting } = this.props.appConfigs;
    const FEATURES = Features_Setting ? Features_Setting : {};

    const talonFlag =
      FEATURES && FEATURES?.find((feature) => feature.Name === 'ShowTalon');

    talonFlag && talonFlag.Status === true
      ? this.setState({ isTalon: true })
      : this.setState({ isTalon: false });

    const cName = HttpHeader.getCNAME();
    if (cName.includes('keenan') || cName.includes('tpabenefits')) {
      this.setState({ isKeenan: true });
    }
    if (MemberSummary.getMemberType() === 'Employee')
      this.setState({ MemberFlag: false });

    console.log(
      'MemberSummary.getMemberType(): ',
      MemberSummary.getMemberType(),
    );

    this.setState({ spendingSummaryLoading: true });
    if (SpendingAccountSummary.getSpendingAccountSummary() != null) {
      this.setState({ spendingSummaryLoading: false });
      this.setState({ isSpendingSummaryNotFound: false });
      this.setState({ isAPIFailed: false });
      console.log('Spending Summary Cached');
    } else {
      RetryAPI.setResponseReceived(false);
      RetryAPI.resetRetryCount();
      while (RetryAPI.performRetry()) {
        console.log('Calling Spending Summary');
        const spendingAccountResponse =
          this._isMounted && (await this.getSpendingAccountSummary());
        if (RetryAPI.getResponseReceived()) break;
      }

      if (RetryAPI.retryFailed()) {
        this.setState({ spendingSummaryLoading: true }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE
        const errorCode = RetryAPI.getErrorCode();
        console.log('Spending Summary Error Code: ', errorCode);
        HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');
        this.setState({ isAPIFailed: true });
        //Process Client Errors
        if (
          HttpErrorHandler.ProcessedClientErrors(
            errorCode,
            'view spending summary. ',
          )
        ) {
          if (errorCode == HttpErrorCodes.HTTP_ERROR_CODE_404) {
            this.setState({ MemberFlag: true });
            this.setState({ isSpendingSummaryNotFound: true });
            SpendingAccountSummary.setMemberFlag(this.state.MemberFlag);
            MemberSummary.setSideMenuPermissions(true);
            this.setState({ spendingSummaryLoading: false }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE
          } else {
            console.log('SPENDING SUMMARY CLIENT ERROR');
            this.setState({ clientErrorSS: true });
            this.setState({ spendingSummaryLoading: false });
          }
        } else {
          //Handle Excpetion
          if (
            HttpErrorHandler.ProcessedException(
              errorCode,
              'We are unable to render your Spending Summary Account Information now.',
            )
          ) {
            this._isMounted = true;
            console.log('Spending Account Summary  - no data found');
          }
        }
      }
    }
    this.props.getSideMenuPermissions();
    if (MasterPermissions.CheckPermission('View Claims')) {
      this.setState({ claimStatusLoading: true });
      if (ClaimStatusSummary.getClaimStatusSummary() != null) {
        this.setState({ claimStatusLoading: false });
        console.log('Claim Status Summary Cached');
      } else {
        RetryAPI.setResponseReceived(false);
        RetryAPI.resetRetryCount();
        while (RetryAPI.performRetry()) {
          const claimResponse =
            this._isMounted && (await this.getClaimStatusSummary());
          if (RetryAPI.getResponseReceived()) break;
        }

        if (RetryAPI.retryFailed()) {
          this.setState({ claimStatusLoading: true }); //CREATE A NEW FLAG TO DISPLAY ERROR MESSAGE
          const errorCode = RetryAPI.getErrorCode();
          console.log('Claim Status Summary Error Code: ', errorCode);
          HttpErrorHandler.DisplayServerErrorMessage(errorCode, '');

          //Process Client Errors
          if (
            HttpErrorHandler.ProcessedClientErrors(
              errorCode,
              'view claim status summary. ',
            )
          ) {
            console.log('Claim status summary ErrorCode: ', errorCode);
            if (errorCode == HttpErrorCodes.HTTP_ERROR_CODE_404) {
              console.log('Claim status summary - no data found');
              this.setState({ claimStatusLoading: false });
              claimsData = [];
            } else {
              this.setState({ clientErrorCS: true, claimStatusLoading: false });
            }
          } else {
            //Handle Excpetion
            if (
              HttpErrorHandler.ProcessedException(
                errorCode,
                'We are unable to render your Claims Status Summary now.',
              )
            ) {
              //this._isMounted = true;
              claimsData = [];
              this.setState({ statusCS: 500 });
              this.setState({ isAPIFailed: true });
              this.setState({ claimStatusLoading: false });
              console.log('Claims Status Summary  - no data found');
            }
          }
        }
      }
    }

    //if ( this._isMounted ) {
    //console.log( 'Claim Status Summary Server Error: ', this._isMounted );
    //this.setState( { serverError: true } );
    //this._isMounted = false;
    //}
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getSpendingAccountSummary = async () => {
    let response;
    let spendingAccountSummaryResp;
    let noOfAccounts;

    try {
      const response = await axiosInstance.get(
        APIEndpoints.getSpendingSummaryResource() +
          MemberSummary.getMemberType() +
          '/oid/' +
          MemberSummary.getMemberOID(), //should end here
        //+ '/year/2017'
      );

      spendingAccountSummaryResp = response.data;

      this.setState({
        getSpendingAccountSummary:
          spendingAccountSummaryResp.Response.SpendingAccounts,
      });

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        SpendingAccountSummary.setSpendingAccountSummary(
          spendingAccountSummaryResp,
        );
        console.log(
          'Spending Account Summary RESPONSE Received ==== : ',
          spendingAccountSummaryResp,
        );
        console.log('Spending Account Summary successfull', response.status);

        if (JSON.stringify(spendingAccountSummaryResp.Response) === '{}') {
          console.log('Spending Account Summary  - no data found');
          SpendingAccountSummary.setAmountSpent(0, 0);
          SpendingAccountSummary.setAnnualContribution(0, 0);
        } else {
          spendingAccountSummaryResp =
            SpendingAccountSummary.getSpendingAccountSummary();
          noOfAccounts =
            spendingAccountSummaryResp.Response.SpendingAccounts.length;
        }
        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
        this.setState({ spendingSummaryLoading: false });
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response.status);

        this.setState({ spendingSummaryLoading: true });
        console.log('Spending Account Summary failed', response);
      }
    } catch (error) {
      this.setState({ isAPIFailed: true });
      if (error.toString().includes('404')) {
        this.setState({ isNotFound: true });
      }
      if (error) {
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        RetryAPI.setErrorCode(error.response.status);
      }

      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);

      this.setState({ spendingSummaryLoading: true });
    }
    return response;
  };

  getEachIndividualCounts = (status, internalStatus, claimSummary) => {
    const indvidualRecord = {
      Status: status,
      InternalStatus: internalStatus,
      Count: 0,
      DisplayOnDashboard: 'true',
    };
    const activeCount = claimSummary.filter((data) => data.Status === status);
    if (activeCount.length > 0) {
      indvidualRecord.Count = activeCount[0].Count;
    }
    return indvidualRecord;
  };

  fetchClaimLabelSummary = async () => {
    const { Network_Setting } = this.props.appConfigs;
    const resourceData = await axiosInstance.get(
      `${APIEndpoints.getAllClaimLabelsLIst()}`,
    );
    const resourceList = resourceData?.data?.Response?.ClaimStatusLabels;
    const displayOnDashboardList = resourceList.filter(
      (rData) => rData.DisplayOnDashboard === true,
    );
    const displayOnDashboardUniqueStatus = [];
    displayOnDashboardList.forEach((eachRecord) => {
      if (
        displayOnDashboardUniqueStatus.findIndex(
          (eachRow) =>
            eachRow.ExternalStatusMemberDependent ==
            eachRecord.ExternalStatusMemberDependent,
        ) == -1
      ) {
        displayOnDashboardUniqueStatus.push(eachRecord);
      }
    });
    displayOnDashboardUniqueStatus.sort((a, b) =>
      a.ExternalStatusMemberDependent > b.ExternalStatusMemberDependent
        ? 1
        : b.ExternalStatusMemberDependent > a.ExternalStatusMemberDependent
        ? -1
        : 0,
    );
    ClaimsList.setDisplayOnDashboardList(displayOnDashboardUniqueStatus);
    const claimsResArray = [];
    const dashboardClaimsList = [];
    displayOnDashboardUniqueStatus.forEach((eachRecord, index) => {
      dashboardClaimsList.push({
        Status: eachRecord.ExternalStatusMemberDependent,
        InternalStatus: eachRecord.InternalStatus,
        Count: 0,
        DisplayOnDashboard: 'true',
      });
    });
    if (Network_Setting?.Display_Last_Five_Claims_In_Dashboard === true) {
      dashboardClaimsList.unshift({
        Status: 'LAST CLAIMS',
        InternalStatus: 'LAST CLAIMS',
        Count: 0,
        DisplayOnDashboard: 'true',
      });
    }
    return dashboardClaimsList;
  };

  getClaimStatusSummary = async () => {
    let response;
    let claimStatusSummaryResp;
    const { Common_Setting, Network_Setting } = this.props.appConfigs;
    const claimsYearRange =
      Common_Setting?.Claims_Year_Range != undefined
        ? Common_Setting?.Claims_Year_Range
        : 5;
    //Fetching Claims summary
    const fromDate = new Date().getFullYear() - claimsYearRange + '-01-01';
    const toDate = moment(new Date()).format('YYYY-MM-DD');
    try {
      const response = await axiosInstance.get(
        APIEndpoints.getClaimStatusSummaryReource() +
          MemberSummary.getLoggedInMemberType() +
          '/oid/' +
          MemberSummary.getLoggedInUserOID() +
          '/incurreddatefrom/' +
          fromDate +
          '/incurreddateto/' +
          toDate,
        //+ '/family/true'
        //+ '/claimstatusmonths/150/family/true'
      );
      const resourceData = await axiosInstance.get(
        `${APIEndpoints.getAllClaimLabelsLIst()}`,
      );
      const resourceList = resourceData?.data?.Response?.ClaimStatusLabels;
      const displayOnDashboardList = resourceList.filter(
        (rData) => rData.DisplayOnDashboard === true,
      );
      const displayOnDashboardUniqueStatus = [];
      displayOnDashboardList.forEach((eachRecord) => {
        if (
          displayOnDashboardUniqueStatus.findIndex(
            (eachRow) =>
              eachRow.ExternalStatusMemberDependent ==
              eachRecord.ExternalStatusMemberDependent,
          ) == -1
        ) {
          displayOnDashboardUniqueStatus.push(eachRecord);
        }
      });
      displayOnDashboardUniqueStatus.sort((a, b) =>
        a.ExternalStatusMemberDependent > b.ExternalStatusMemberDependent
          ? 1
          : b.ExternalStatusMemberDependent > a.ExternalStatusMemberDependent
          ? -1
          : 0,
      );
      ClaimsList.setDisplayOnDashboardList(displayOnDashboardUniqueStatus);
      claimStatusSummaryResp = response.data;
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        this.setState({ statusCS: 200 });
        RetryAPI.setErrorCode(response.status);
        ClaimStatusSummary.setClaimStatusSummary(claimStatusSummaryResp);
        console.log(
          'Claim Status Summary RESPONSE Received ==== : ',
          claimStatusSummaryResp,
        );
        console.log('Claim Status Summary successfull', response.status);
        if (JSON.stringify(response.data.Response) === '{}') {
          console.log('Claim status summary - no data found');
          ClaimStatusSummary.claimStatus.push(
            {
              status: 'LAST CLAIMS',
              statusCount: 0,
              statusDescription: <br />,
            },
            {
              status: 'PROCESSING',
              statusCount: 0,
              statusDescription: 'Currently under process',
            },
            {
              status: 'PAID CLAIMS',
              statusCount: 0,
              statusDescription: 'Last 6 months',
            },
            {
              status: 'NEED ATTENTION',
              statusCount: 0,
              statusDescription: 'Pending Claims',
            },
          );
        } else {
          const statusDesc = '';
          claimStatusSummaryResp = ClaimStatusSummary.getClaimStatusSummary();
          let claimsResArray =
            claimStatusSummaryResp?.Response?.ClaimSummary || [];
          const LastClaims = claimsResArray.find(
            (claims) => claims.Status === 'LAST CLAIMS',
          );
          claimsResArray = claimsResArray.filter(
            (claims) => claims.Status !== 'LAST CLAIMS',
          );
          const dashboardClaimsList = [];
          if (Network_Setting?.Display_Last_Five_Claims_In_Dashboard === true) {
            dashboardClaimsList.unshift(LastClaims);
          }
          displayOnDashboardUniqueStatus.forEach((eachRecord, index) => {
            dashboardClaimsList.push(
              this.getEachIndividualCounts(
                eachRecord.ExternalStatusMemberDependent,
                eachRecord.InternalStatus,
                claimsResArray,
              ),
            );
          });
          console.log(
            dashboardClaimsList,
            'claimsData',
            LastClaims,
            'LastClaims',
          );
          claimsData = dashboardClaimsList;
          console.log('Claim Status  Summary successfull', ClaimStatusSummary);
          this.setState({ claimStatusLoading: true });
        }
        RetryAPI.resetRetryCount();
        RetryAPI.setResponseReceived(true);
        this.setState({ claimStatusLoading: false });
      } else {
        RetryAPI.incrementRetryCount();
        RetryAPI.setResponseReceived(false);
        RetryAPI.setErrorCode(response.status);

        this.setState({ claimStatusLoading: true });
        console.log('Claim Status  Summary failed', response);
      }
    } catch (error) {
      claimsData = await this.fetchClaimLabelSummary();
      this.setState({ isAPIFailed: true });
      this.setState({ statusCS: error.response.status });

      console.log('Claim Status Summary Exception: ', error);
      if (error) {
        RetryAPI.setErrorCode(HttpErrorCodes.HTTP_REQUEST_ABORTED);
      }
      if (error.response) {
        console.log('Data: ', error.response.data);
        console.log('Header: ', error.response.headers);
        console.log('Status: ', error.response.status);
        RetryAPI.setErrorCode(error.response.status);
      }
      RetryAPI.incrementRetryCount();
      RetryAPI.setResponseReceived(false);

      this.setState({ claimStatusLoading: true });
    }
    return response;
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps?.memberSummary?.loggedInUserOID !==
        this.props?.memberSummary?.loggedInUserOID &&
      this.props.memberSummary !== null
    ) {
      this.getClaimStatusSummary();
    }
    if (
      RetryAPI.getErrorCode() === HttpErrorCodes.HTTP_ERROR_CODE_404 &&
      this.state.claimStatusLoading
    ) {
      this.setState({
        isSpendingSummaryNotFound: true,
        claimStatusLoading: false,
      });
    }
  }

  processClaimStatus = (claimStatus) => {
    this.setState({ gotoClaimsTab: false });
    ClaimsList.setClaimStatus(claimStatus);
    ClaimsList.setFilterSelected(true);
    this.setState({ gotoClaimsTab: true });
  };

  render() {
    const { getSpendingAccountSummary } = this.state;
    const height1 = '295px';
    const height2 = '360px';

    const { t } = this.props;

    //if ( this.state.serverError )
    //return ( <Redirect to="/member/server-error" push={true}></Redirect> );

    if (this.state.gotoClaimsTab)
      return <Navigate to="/member/claims" push={true}></Navigate>;

    return (
      <>
        {/*Coverage Widget */}
        {MasterPermissions.CheckPermission('View Coverage Details') &&
          this.state.isKeenan && (
            <Col md={4} sm={12} className="margin-bottom-32">
              <CardGroup>
                <Card
                  className={
                    this.props.webClientType !== 'mobile'
                      ? 'dashboard-card-container mb-0'
                      : 'mb-0'
                  }
                >
                  <Card.Body
                    className="dashboard-data-space"
                    aria-label="Details of Claims Status"
                  >
                    <h3 className="spending-summary">Coverages</h3>
                    <SimpleCoverage />
                  </Card.Body>
                </Card>
              </CardGroup>
            </Col>
          )}

        <Feature name="spendingAccount">
          {MasterPermissions.CheckPermission('View Spending Account Details') &&
            !this.state.isSpendingSummaryNotFound && (
              <Col xs={12} sm={12} md={8} lg={8} className="margin-bottom-32">
                <CardGroup className="dashboard-box-item">
                  <Card className="dashboard-card-container mb-0">
                    <Card.Body className="dashboard-data-space">
                      <Row className="spending-widget m-0">
                        {this.state.spendingSummaryError && (
                          //<Card.Body className="dashboard-data-space">
                          //<Row className="spending-widget m-0">
                          <span role="alert" aria-live="polite">
                            {t('member.dashboard.spending.spending_error')}
                          </span>
                          //</Row>
                          //</Card.Body>
                        )}

                        {this.state.spendingSummaryLoading &&
                          !this.state.clientErrorSS &&
                          !this.state.isSpendingSummaryNotFound && (
                            <>
                              <SpendingSummarySkeleton />
                            </>
                          )}

                        {!this.state.spendingSummaryLoading &&
                          !this.state.clientErrorSS &&
                          !this.state.isSpendingSummaryNotFound && (
                            <>
                              <div className="d-block d-md-block col-md-12 col-lg-6 p-0">
                                <h3 className="spending-summary">
                                  <span className="sr-only">Details of</span>{' '}
                                  {t('member.dashboard.spending.summary_title')}
                                </h3>
                                <span id="hsa-member-id">
                                  {/*<AccountsSVG.AccountSVG /> */}
                                  {
                                    SpendingAccountSummary
                                      .spendingAccountSummary.Response
                                      .SpendingAccounts[0].AccountType
                                  }{' '}
                                  - Account{' '}
                                  {SpendingAccountSummary.spendingAccountSummary
                                    .Response.SpendingAccounts.length < 0
                                    ? '(PRIMARY)'
                                    : null}
                                  {console.log(
                                    'SpendingAccountSummarydata',
                                    SpendingAccountSummary
                                      .spendingAccountSummary.Response
                                      .SpendingAccounts.length,
                                  )}
                                </span>
                                <div className="before-circle">
                                  {t(
                                    'member.dashboard.spending.available_balance',
                                  )}
                                </div>
                                <div className="avail-bal">
                                  {formatter.format(
                                    SpendingAccountSummary
                                      .spendingAccountSummary.Response
                                      .SpendingAccounts[0].AnnualContribution -
                                      SpendingAccountSummary
                                        .spendingAccountSummary.Response
                                        .SpendingAccounts[0].AmountSpent,
                                  )}
                                </div>
                                <ProgressBar
                                  completed={findPercentage(
                                    SpendingAccountSummary
                                      .spendingAccountSummary.Response
                                      .SpendingAccounts[0].AmountSpent,
                                    SpendingAccountSummary
                                      .spendingAccountSummary.Response
                                      .SpendingAccounts[0].AnnualContribution,
                                  )}
                                />
                                <Row className="clear-both">
                                  <Col>
                                    <div className="before-circle-light">
                                      {t('member.dashboard.spending.spent_amt')}{' '}
                                      {formatter.format(
                                        SpendingAccountSummary
                                          .spendingAccountSummary.Response
                                          .SpendingAccounts[0].AmountSpent,
                                      )}{' '}
                                      of{' '}
                                      <span className="font-weight-bold">
                                        {formatter.format(
                                          SpendingAccountSummary
                                            .spendingAccountSummary.Response
                                            .SpendingAccounts[0]
                                            .AnnualContribution,
                                        )}
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                                <Row className="clear-both">
                                  <Col className="mt-3">
                                    {SpendingAccountSummary
                                      .spendingAccountSummary.Response
                                      .SpendingAccounts.length < 0 ? (
                                      <p className="showall">
                                        <img
                                          src={require('../../../img/payment-icon.png')}
                                          alt="Payment"
                                          className="account-icon spending-black"
                                        ></img>
                                        <a
                                          href="/member/dashboard-work-in-progress"
                                          id="fsa-message-display"
                                        >
                                          <span>
                                            &nbsp;
                                            {
                                              SpendingAccountSummary
                                                .spendingAccountSummary.Response
                                                .SpendingAccounts[0].AccountType
                                            }{' '}
                                            - ACCOUNT{' '}
                                          </span>
                                          &nbsp;
                                          <FontAwesomeIcon
                                            icon="arrow-right"
                                            className="spending-FAS-account"
                                          />
                                        </a>
                                      </p>
                                    ) : null}
                                    <Link
                                      to="/member/accounts"
                                      className="acc-det-link"
                                    >
                                      <span className="ml-0">
                                        {' '}
                                        {t(
                                          'member.dashboard.spending.show_details',
                                        )}
                                      </span>
                                    </Link>
                                  </Col>
                                </Row>
                              </div>
                              {/*Mobile className="d-block d-md-none col-xs-12 col-sm-12 p-0"*/}
                              <Col className="d-none d-lg-block col-lg-6">
                                <p className="summary-details">
                                  {t('member.dashboard.spending.summary_para')}
                                </p>
                              </Col>
                            </>
                          )}

                        {this.state.isSpendingSummaryNotFound &&
                        !this.state.spendingSummaryLoading ? (
                          <div
                            className="d-block d-md-block col-md-12 p-0 spending-no-data"
                            aria-label="Details of Spending Summary"
                          >
                            <h3 className="spending-summary">
                              {t('member.dashboard.spending.summary_title')}
                            </h3>
                            <Row>
                              <Col className="col-sm-6">
                                <div className="mx-auto text-center mt-4">
                                  <NoSpendingDataSVG />
                                </div>
                              </Col>
                              <Col className="col-sm-6">
                                <h4>
                                  {t('member.dashboard.spending.no_data_found')}
                                </h4>
                                <p className="mr-3">
                                  {t('member.dashboard.spending.try_again')}
                                </p>
                              </Col>
                            </Row>
                          </div>
                        ) : (
                          !SpendingAccountSummary && (
                            <div
                              className="d-block d-md-block col-md-12 p-0 spending-no-data"
                              aria-label="Details of Spending Summary"
                            >
                              <h3 className="spending-summary">
                                {t('member.dashboard.spending.summary_title')}
                              </h3>
                              <Row>
                                <Col className="col-sm-6">
                                  <div className="mx-auto text-center mt-4">
                                    <img
                                      src={require('../../../img/client-error.png')}
                                      id="tick-img"
                                      alt="Check Mark"
                                    />
                                  </div>
                                </Col>
                                <Col className="col-sm-6">
                                  <h4>
                                    {t(
                                      'member.dashboard.spending.something_wrong',
                                    )}
                                  </h4>
                                  <p className="mr-3">
                                    {t(
                                      'member.dashboard.spending.error_encountered',
                                    )}
                                  </p>
                                </Col>
                              </Row>
                            </div>
                          )
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                </CardGroup>
              </Col>
            )}
        </Feature>

        {/*CLAIMS WIDGET STARTS HERE */}
        {MasterPermissions.CheckPermission('View Claims') && (
          <Col md={4} sm={12} className="margin-bottom-32">
            <CardGroup>
              <Card
                className={
                  this.props.webClientType !== 'mobile'
                    ? 'dashboard-card-container mb-0'
                    : 'mb-0'
                }
              >
                <Card.Body
                  className="dashboard-data-space"
                  aria-label="Details of Claims Status"
                >
                  <h3 className="spending-summary">
                    {t('member.dashboard.spending.claims_status')}
                  </h3>

                  {this.state.claimStatusLoading && (
                    <Row className=" mr-0">
                      {Array(4)
                        .fill()
                        .map((ele, i) => {
                          return (
                            <Col key={i} xs={3} md={6} className="pr-0 mb-3">
                              <Skeleton />
                            </Col>
                          );
                        })}
                    </Row>
                  )}

                  {!this.state.claimStatusLoading &&
                    this.state.statusCS === 200 && (
                      <Row className="mr-0 claim-boxes-container ">
                        {
                          //ClaimStatusSummary.claimStatus[ 0 ].statusCount>0&&
                          claimsData &&
                            claimsData.map((ClaimsData, index) => {
                              return (
                                ClaimsData.DisplayOnDashboard === 'true' && (
                                  <Col
                                    key={index}
                                    md={6}
                                    xs={3}
                                    className="pr-0 claim-box-wrapper  mb-3 "
                                  >
                                    <div
                                      className={
                                        ClaimsData.Count > 0
                                          ? 'claim-box pointer'
                                          : 'claim-box-disable'
                                      }
                                    >
                                      <div
                                        className="processClaim"
                                        onClick={() =>
                                          ClaimsData.Count > 0 &&
                                          this.processClaimStatus(
                                            ClaimsData.Status,
                                          )
                                        }
                                      >
                                        <div className="h3">
                                          {ClaimsData.Count}
                                        </div>
                                        <div className="h5">
                                          {ClaimsData.Status}
                                          {ClaimsData.InternalStatus ===
                                            'PAID' && (
                                            <span className="status-subtext-paid">
                                              {' '}
                                              ( Last 6 months )
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                )
                              );
                            })
                        }
                      </Row>
                    )}

                  {!this.state.claimStatusLoading &&
                  this.state.isAPIFailed &&
                  this.state.statusCS !== 200 ? (
                    <Row>
                      <Col className="col-sm-12">
                        <div className="">
                          {/*<img
                            src={require( '../../../img/client-error.svg' )}
                            id="tick-img"
                            alt="Check Mark"
                            className="w-50"
                          /> */}
                          <ClientErrorSVG
                            className="client-error-mark"
                            parentClassName="clienterrorsvg"
                            circleClass="error-circle"
                            svgHeight={true}
                          />
                        </div>
                        <h3 className="pt-3 text-center">
                          {this.state.statusCS === 404 && 'No claims found'}
                          {this.state.statusCS === 403 &&
                            'No permission to view claims'}
                          {this.state.statusCS !== 403 &&
                            this.state.statusCS !== 404 &&
                            'Something went wrong with request!'}
                        </h3>
                        <p className="text-center">
                          {this.state.statusCS === 403 &&
                            'You do not have permission to access this resource due to HIPAA Patient restrictions'}
                          {/*{this.state.statusCS !== 403 && 'Please try again.'} */}
                        </p>
                      </Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </Card.Body>
              </Card>
            </CardGroup>
          </Col>
        )}
        {/*CLAIMS WIDGET ENDS HERE */}
        {/*Prime Widget */}
        <PrimeWidget />

        {/*FIND CARE WIDGET */}
        <Feature name="findProvider">
          <FindCare findCareWidgetMode={this.findCareWidgetMode} />
        </Feature>
        {this.state.isTalon && <Talon />}

        {/*RESOURCES WIDGET */}
        <Resources />

        {/*Price Comparison WIDGET */}
        <Feature name="EstimateCostMember">
          {MasterPermissions.CheckPermission(
            'Access to Cost Estimator Tool',
          ) && (
            <Col md={4} sm={12} className="margin-bottom-32">
              <PriceCompare />
            </Col>
          )}
        </Feature>
      </>
    );
  }
}

const mapStateToProps = ({ app, memberSummary }) => {
  return {
    webClientType: app.clientType,
    appConfigs: app.appConfigs,
    memberSummary,
  };
};

export default withTranslation()(connect(mapStateToProps)(SpendingSummary));
